"use client";
import React, {useRef, useImperativeHandle, forwardRef} from "react";
import Slider from "react-slick";
import type {Settings} from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export type CarouselRef = {
    next: () => void;
    previous: () => void;
}

type CarouselProps = {
    children?: React.ReactNode;
    settings?: Settings;
}

const defaultSettings: Settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
}

const Carousel = forwardRef<CarouselRef, CarouselProps>((props, ref) => {
    const {
        children
    } = props;

    useImperativeHandle(ref, () => ({
        next,
        previous
    }))

    let sliderRef: any = useRef(null);

    const mergeSettings = {
        ...defaultSettings,
        ...props.settings
    }

    const next = () => {
        sliderRef.slickNext();
    }

    const previous = () => {
        sliderRef.slickPrev();
    }

    return (
        <Slider
            ref={slider => {sliderRef = slider}}
            {...mergeSettings}
        >
            {children}
        </Slider>
    )
})

export default Carousel;